/**
 * Created by Zac on 25/04/2016.
 */
$(document).ready(function () {
    var advCurActivities = [];

    $('.slider-pro').each(function () {

        var auto = Boolean($(this).data("autoplay"));
        var w = $(this).data("width");
        var h = $(this).data("height");
        var forwardandback = Boolean($(this).data("forwardandback"));
        var indicators = Boolean($(this).data("indicators"));
        var transition = Boolean($(this).data("transition"));

        var result = $(this).sliderPro({
            width: w,
            height: h,
            fade: transition,
            arrows: forwardandback,
            buttons: indicators,
            touchSwipe: false,
            autoplay: auto,
            autoScaleLayers: false,
            fadeArrows: false,
            loop: false
        });
        // if ($(this).data('restrictChange') == true){
        //     $(this).find('.s');
        // }
        function slideProcessor(nextSlide) {

            var activityInteractions = nextSlide.children('.sp-layer').children('.isActivity').find('ul, .btn-group, .feedback-button');
            if (activityInteractions.length > 0){
                $('.sp-next-arrow').hide();

            }
            advCurActivities = [];
            $.each(activityInteractions, function(){
                advCurActivities.push($(this).attr('id'));
            });

            activityInteractions.click(function (event) {
                advCurActivities.splice(advCurActivities.indexOf($(this).attr('id')), 1);
                //console.log(advCurActivities.indexOf($(this).attr('id')));
                $(this).unbind(event);
                if (advCurActivities.length == 0) $('.sp-next-arrow').show();
            })

        }

        if ($(this).attr('data-restrictChange') == true) {

            $(this).on('gotoSlide', function (event) {
                var nextSlide = $(this).find('.sp-slide[data-index="' + event.index + '"]').first();
                slideProcessor(nextSlide);
            });

            $(document).on('changeScene', function (event) {
                var nextSlide = $('[data-scene="' + event.message + '"]').find('.sp-slide').first();
                slideProcessor(nextSlide);
            });
        }
        //sequence.sequence(options).data('sequence');
    });

    $('.sp-slide').css('width', '100%');
    $('.sp-mask').css('width', '100%');

});


// WEBPACK FOOTER //
// Glasshouse/Core/js/advSlider.js